import { render, staticRenderFns } from "./BulkPickUp.vue?vue&type=template&id=acdd297c&"
import script from "./BulkPickUp.vue?vue&type=script&lang=js&"
export * from "./BulkPickUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports